/**
 * 国际项目数据。
 * 数据来源：biz_internation_project 中 supplier=14 的最新项目，id 对应数据库 code。
 */
export const internationalProjects = [
  { id: 'KT', name: 'KakaoTalk' },
  { id: 'NV', name: 'Naver' },
  { id: 'OI', name: 'Tinder' },
  { id: 'IG', name: 'Instagram' },
  { id: 'TG', name: 'Telegram' },
  { id: 'DH', name: 'Ebay' },
  { id: 'VI', name: 'Viber' },
  { id: 'FB', name: 'Facebook' },
  { id: 'GO', name: 'Google, Gmail, Youtube' },
  { id: 'ME', name: 'LINE' },
  { id: 'MT', name: 'Steam' },
  { id: 'TS', name: 'PayPal' },
  { id: 'WA', name: 'WhatsApp' },
  { id: 'BZ', name: 'Blizzard' },
  { id: 'NF', name: 'Netflix' },
  { id: 'TW', name: 'Twitter' },
  { id: 'NZ', name: 'Foodpanda' },
  { id: 'VK', name: 'ВК, Одноклассники, Юла (mail.ru group)' },
  { id: 'UB', name: 'Uber' },
  { id: 'MM', name: 'Microsoft' },
  { id: 'UK', name: 'AirBnb' },
  { id: 'MB', name: 'Yahoo' },
  { id: 'AM', name: 'Amazon' },
  { id: 'AB', name: 'Alibaba' },
  { id: 'WC', name: 'Craigslist' },
  { id: 'EW', name: 'Nike' },
  { id: 'LF', name: 'Tiktok' },
  { id: 'KA', name: 'Shopee' },
  { id: 'ZA', name: 'Jingdong' },
  { id: 'QQ', name: 'Tencent QQ' },
  { id: 'IM', name: 'IMO messenger' },
  { id: 'YL', name: 'Yalla' },
  { id: 'PM', name: 'AOL' },
  { id: 'ZK', name: 'Deliveroo' },
  { id: 'LS', name: 'Careem' },
  { id: 'ZR', name: 'Papara' },
  { id: 'HW', name: '支付宝、微信支付、QQ钱包' },
  { id: 'DS', name: 'Discord' },
  { id: 'AN', name: 'Adidas' },
  { id: 'XK', name: 'DiDi taxi' },
  { id: 'WB', name: 'WeChat' },
  { id: 'MC', name: 'MiChat' },
  { id: 'BFF', name: 'Buff.163' },
  { id: 'IP', name: 'Burger King' },
  { id: 'SI', name: 'Cita Previa' },
  { id: 'FR', name: 'DANA' },
  { id: 'HK', name: '4FunLite' },
  { id: 'YW', name: 'Grindr' },
  { id: 'NI', name: 'Gojek' },
  { id: 'XS', name: 'GroupMe' },
  { id: 'AE', name: 'MyGLO' },
  { id: 'UN', name: 'Humble bundle' },
  { id: 'XF', name: 'LightChath' },
  { id: 'FZ', name: 'KFC' },
  { id: 'ZO', name: 'Kaggle' },
  { id: 'RY', name: 'McDonalds' },
  { id: 'VM', name: 'Okcupid' },
  { id: 'SN', name: 'OLX' },
  { id: 'FX', name: 'Pgbonus' },
  { id: 'JQ', name: 'Paysafecard' },
  { id: 'PF', name: 'Plenty of Fish' },
  { id: 'DP', name: 'Protonmail' },
  { id: 'NC', name: 'Payoneer' },
  { id: 'QI', name: '32Red' },
  { id: 'IJ', name: 'Revolut' },
  { id: 'SCRF', name: 'Scruff' },
  { id: 'TCW', name: 'Switchere' },
  { id: 'ALJ', name: 'Spotify' },
  { id: 'BW', name: 'Signal' },
  { id: 'VJ', name: 'Stormgain' },
  { id: 'HB', name: 'Twitch' },
  { id: 'GR_TL', name: 'Tilda' },
  { id: 'XD', name: 'Tokopedia' },
  { id: 'GC', name: 'TradingView' },
  { id: 'YOHO', name: 'YoHo' },
  { id: 'QY', name: 'Zhihu' },
  { id: 'KF', name: 'Weibo' },
  { id: 'WX', name: 'Apple' },
  { id: 'KC', name: 'Vinted' },
  { id: 'TN', name: 'LinkedIn' },
  { id: 'BL', name: 'Bigo Live' },
  { id: 'RC', name: 'Skype' },
  { id: 'FU', name: 'Snapchat' },
  { id: 'FI', name: 'Dundle' },
  { id: 'VZ', name: 'Hinge' },
  { id: 'WH', name: 'TanTan' },
  { id: 'DR', name: 'OpenAI (ChatGPT)' },
  { id: 'UL', name: 'Getir' },
  { id: 'PY', name: 'Monese' },
  { id: 'LT', name: 'Bitclout' },
  { id: 'TX', name: 'Bolt' },
  { id: 'GT', name: 'Gett' },
  { id: 'SS', name: 'Hezzl' },
  { id: 'DL', name: 'Lazada' },
  { id: 'XH', name: 'Ovo' },
  { id: 'VV', name: 'Seo Sprint' },
  { id: 'TL', name: 'Truecaller' },
  { id: 'MJ', name: 'Zalo' },
  { id: 'OZ', name: 'Poshmark' },
  { id: 'ZZ', name: 'DENT' },
  { id: 'WG', name: 'Skout' },
  { id: 'QD', name: 'Taobao' },
  { id: 'OS', name: 'Dhani' },
  { id: 'HN', name: '1688' },
  { id: 'JU', name: 'Indomaret' },
  { id: 'GF', name: 'GoogleVoice' },
  { id: 'DO', name: 'Leboncoin' },
  { id: 'YY', name: 'Venmo' },
  { id: 'CN', name: 'Fiverr' },
  { id: 'II', name: 'CashKaro' },
  { id: 'IR', name: 'Chispa' },
  { id: 'IT', name: 'CashApp' },
  { id: 'IX', name: 'Celcoin' },
  { id: 'JD', name: 'GiraBank' },
  { id: 'JW', name: 'Br777' },
  { id: 'JY', name: 'Sorare' },
  { id: 'KK', name: 'Idealista' },
  { id: 'KQ', name: 'FotoCasa' },
  { id: 'QF', name: 'RedBook' },
  { id: 'ET', name: 'Clubhouse' },
  { id: 'MO', name: 'Bumble' },
  { id: 'PZ', name: 'Lidl' },
  { id: 'YI', name: 'Yemeksepeti' },
  { id: 'IB', name: 'Immowelt' },
  { id: 'EX', name: 'Linode' },
  { id: 'RR', name: 'Wolt' },
  { id: 'BF', name: 'Keybase' },
  { id: 'XR', name: 'Tango' },
  { id: 'XV', name: 'Wish' },
  { id: 'XX', name: 'Joyride' },
  { id: 'ZH', name: 'Zoho' },
  { id: 'LQ', name: 'Potato' },
  { id: 'DN', name: 'Paxful' },
  { id: 'IQ', name: 'icq' },
  { id: 'JG', name: 'Grab' },
  { id: 'EN', name: 'Hermes' },
  { id: 'EZ', name: 'GoerliFaucet' },
  { id: 'OH', name: 'MapleSEA' },
  { id: 'YO', name: 'Amasia' },
  { id: 'YS', name: 'ZCity' },
  { id: 'ZS', name: 'Bilibili' },
  { id: 'VP', name: 'Kwai' },
  { id: 'RL', name: 'inDriver' },
  { id: 'FJ', name: 'Potato Chat' },
  { id: 'ZX', name: 'CommunityGaming' },
  { id: 'PU', name: 'Justdating' },
  { id: 'AJ', name: 'OneAset' },
  { id: 'GJ', name: 'Carousell' },
  { id: 'ZY', name: 'Nttgame' },
  { id: 'ZW', name: 'Quack' },
  { id: 'ZV', name: 'Digikala' },
  { id: 'ZU', name: 'BigC' },
  { id: 'ZT', name: 'Budweiser' },
  { id: 'ZQ', name: 'IndiaPlays' },
  { id: 'ZN', name: 'Biedronka' },
  { id: 'ZM', name: 'OfferUp' },
  { id: 'ZJ', name: 'ROBINHOOD' },
  { id: 'ZG', name: 'Setel' },
  { id: 'ZF', name: 'OnTaxi' },
  { id: 'ZD', name: 'Zilch' },
  { id: 'YX', name: 'JTExpress' },
  { id: 'YV', name: 'IPLwin' },
  { id: 'YP', name: 'Payzapp' },
  { id: 'YN', name: 'Allegro' },
  { id: 'YJ', name: 'eWallet' },
  { id: 'YD', name: '米画师Mihuashi' },
  { id: 'XZ', name: 'paycell' },
  { id: 'XY', name: 'Depop' },
  { id: 'XW', name: 'Taki' },
  { id: 'XU', name: 'RecargaPay' },
  { id: 'XQ', name: 'MPL' },
  { id: 'XN', name: 'Familia' },
  { id: 'XL', name: 'Wmaraci' },
  { id: 'XI', name: 'InFund' },
  { id: 'XE', name: 'GalaxyChat' },
  { id: 'XB', name: 'RummyOla' },
  { id: 'WZ', name: 'FoxFord' },
  { id: 'WW', name: 'BIP' },
  { id: 'WV', name: 'AIS' },
  { id: 'WT', name: 'IZI' },
  { id: 'WQ', name: 'Leboncoin1' },
  { id: 'WP', name: '163СOM' },
  { id: 'WO', name: 'Parkplus' },
  { id: 'WN', name: 'GameArena' },
  { id: 'WL', name: 'YouGotaGift' },
  { id: 'WK', name: 'Mobile01' },
  { id: 'VY', name: 'Meta' },
  { id: 'VX', name: 'HeyBox' },
  { id: 'VW', name: 'CoinField' },
  { id: 'VQ', name: 'LadyMaria' },
  { id: 'VO', name: 'Brand20ua' },
  { id: 'VN', name: 'Yaay' },
  { id: 'VF', name: 'Q12 Trivia' },
  { id: 'VC', name: 'Banqi' },
  { id: 'VA', name: 'SportGully' },
  { id: 'UZ', name: 'OffGamers' },
  { id: 'UY', name: 'Meliuz' },
  { id: 'UW', name: 'Kirana' },
  { id: 'UV', name: 'BinBin' },
  { id: 'US', name: 'IRCTC' },
  { id: 'UR', name: 'MyDailyCash' },
  { id: 'UQ', name: 'TopDetal' },
  { id: 'UO', name: 'CafeBazaar' },
  { id: 'UJ', name: 'СhampionСasino' },
  { id: 'UI', name: 'RuTube' },
  { id: 'UH', name: 'Yubo' },
  { id: 'UG', name: 'Fiqsy' },
  { id: 'UF', name: 'Eneba' },
  { id: 'UE', name: 'Onet' },
  { id: 'UD', name: 'Disney Hotstar' },
  { id: 'TV', name: 'Flink' },
  { id: 'TU', name: 'Lyft' },
  { id: 'TT', name: 'Ziglu' },
  { id: 'TR', name: 'Paysend' },
  { id: 'TQ', name: 'Swvl' },
  { id: 'TP', name: 'IndiaGold' },
  { id: 'TM', name: 'Akulaku' },
  { id: 'TJ', name: 'dbrUA' },
  { id: 'TI', name: 'cryptocom' },
  { id: 'TF', name: 'Noon' },
  { id: 'TE', name: 'eFood' },
  { id: 'TD', name: 'ChaingeFinance' },
  { id: 'SY', name: 'Brahma' },
  { id: 'SX', name: 'Crowdtap' },
  { id: 'SW', name: 'NCsoft' },
  { id: 'SU', name: 'LOCO' },
  { id: 'SR', name: 'Starbucks' },
  { id: 'SP', name: 'HappyFresh' },
  { id: 'SO', name: 'RummyWealth' },
  { id: 'SM', name: 'YoWin' },
  { id: 'SK', name: 'Skroutz' },
  { id: 'SJ', name: 'HandyPick' },
  { id: 'SF', name: 'SneakersnStuff' },
  { id: 'SE', name: 'Feeld' },
  { id: 'SC', name: 'Voggt' },
  { id: 'SA', name: 'AGIBANK' },
  { id: 'RX', name: 'Sheerid' },
  { id: 'RW', name: 'BLS-SPAIN' },
  { id: 'RV', name: 'Kotak811' },
  { id: 'RU', name: 'HOP' },
  { id: 'RT', name: 'hily' },
  { id: 'RS', name: 'Lotus' },
  { id: 'RP', name: 'hamrahaval' },
  { id: 'RO', name: 'PingCode' },
  { id: 'RN', name: 'neftm' },
  { id: 'RK', name: 'Fotka' },
  { id: 'RI', name: 'BillMill' },
  { id: 'RH', name: 'Ace2Three' },
  { id: 'RF', name: 'Akudo' },
  { id: 'RB', name: 'Tick' },
  { id: 'RA', name: 'KeyPay' },
  { id: 'QX', name: 'WorldRemit' },
  { id: 'QT', name: 'MoneyСontrol' },
  { id: 'QN', name: 'Blued' },
  { id: 'QL', name: 'CMTcuzdan' },
  { id: 'QK', name: 'Bit' },
  { id: 'QG', name: 'MoneyPay' },
  { id: 'QE', name: 'GG' },
  { id: 'QB', name: 'Payberry' },
  { id: 'PX', name: 'Nifty' },
  { id: 'PW', name: 'SellMonitor' },
  { id: 'PT', name: 'Bitaqaty' },
  { id: 'PQ', name: 'CDkeys' },
  { id: 'PH', name: 'SnappFood' },
  { id: 'PC', name: 'Casino, bet, gambling' },
  { id: 'PB', name: 'SkyTV' },
  { id: 'PA', name: 'Gamekit' },
  { id: 'OY', name: 'CashFly' },
  { id: 'OX', name: 'Damejidlo' },
  { id: 'OU', name: 'Gabi' },
  { id: 'OQ', name: 'Vlife' },
  { id: 'OO', name: 'LigaPro' },
  { id: 'OM', name: 'Corona' },
  { id: 'OE', name: 'Codashop' },
  { id: 'OD', name: 'FWDMAX' },
  { id: 'OC', name: 'DealShare' },
  { id: 'OB', name: 'Onlinerby' },
  { id: 'NY', name: 'Pyro Music' },
  { id: 'NU', name: 'Bank cards: worldwide №2' },
  { id: 'NS', name: 'Oldubil' },
  { id: 'NP', name: 'Siply' },
  { id: 'NO', name: 'Virgo' },
  { id: 'NN', name: 'Giftcloud' },
  { id: 'NM', name: 'Thisshop' },
  { id: 'NK', name: 'Gittigidiyor' },
  { id: 'NH', name: 'AlloBank' },
  { id: 'NG', name: 'FunPay' },
  { id: 'NE', name: 'Coindcx' },
  { id: 'MX', name: 'SoulApp' },
  { id: 'MW', name: 'Transfergo' },
  { id: 'MV', name: 'Fruitz' },
  { id: 'MU', name: 'MyMusicTaste' },
  { id: 'MS', name: 'NovaPoshta' },
  { id: 'MR', name: 'Fastmail' },
  { id: 'MQ', name: 'GMNG' },
  { id: 'MP', name: 'Winmasters' },
  { id: 'MN', name: 'RRSA' },
  { id: 'ML', name: 'ApostaGanha' },
  { id: 'MK', name: 'LongHu' },
  { id: 'MF', name: 'Weidian' },
  { id: 'LZ', name: 'Things' },
  { id: 'LW', name: 'MrGreen' },
  { id: 'LU', name: 'Crickpe' },
  { id: 'LR', name: 'Okta' },
  { id: 'LP', name: 'Algida' },
  { id: 'LO', name: 'OPPO' },
  { id: 'LN', name: 'Grofers' },
  { id: 'LK', name: 'PurePlatfrom' },
  { id: 'LJ', name: 'Santander' },
  { id: 'LG', name: 'MediBuddy' },
  { id: 'LE', name: 'E bike Gewinnspiel' },
  { id: 'LD', name: 'Cashmine' },
  { id: 'LA', name: 'ssoidnet' },
  { id: 'KY', name: 'SpatenOktoberfest' },
  { id: 'KX', name: 'Vivo' },
  { id: 'KW', name: 'Foody' },
  { id: 'KV', name: 'Rush' },
  { id: 'KU', name: 'RoyalWin' },
  { id: 'KS', name: 'Hirect' },
  { id: 'KR', name: 'Eyecon' },
  { id: 'KO', name: 'AdaKami' },
  { id: 'KN', name: 'Verse' },
  { id: 'KM', name: 'Rozetka' },
  { id: 'KL', name: 'kolesa.kz' },
  { id: 'KH', name: 'Bukalapak' },
  { id: 'KG', name: 'FreeChargeApp' },
  { id: 'KB', name: 'kufarby' },
  { id: 'JZ', name: 'Kaya' },
  { id: 'JX', name: 'Swiggy' },
  { id: 'JT', name: 'TurkiyePetrolleri' },
  { id: 'JM', name: 'mzadqatar' },
  { id: 'JJ', name: 'Aitu' },
  { id: 'JI', name: 'Monobank' },
  { id: 'JH', name: 'PingPong' },
  { id: 'JE', name: 'Nanovest' },
  { id: 'JB', name: 'Wing Money' },
  { id: 'JA', name: 'Weverse' },
  { id: 'IZ', name: 'Global24' },
  { id: 'IY', name: 'FoodHub' },
  { id: 'IU', name: 'Bykea' },
  { id: 'IH', name: 'TeenPattiStarpro' },
  { id: 'IC', name: 'JoGo' },
  { id: 'IA', name: 'Socios' },
  { id: 'HX', name: 'AliExpress' },
  { id: 'HU', name: 'Ukrnet' },
  { id: 'HT', name: 'Bitso' },
  { id: 'HS', name: 'Asda' },
  { id: 'HR', name: 'JKF' },
  { id: 'HQ', name: 'Magicbricks' },
  { id: 'HP', name: 'Meesho' },
  { id: 'HO', name: 'Cathay' },
  { id: 'HM', name: 'Globus' },
  { id: 'HL', name: 'Band' },
  { id: 'HI', name: 'JungleeRummy' },
  { id: 'HH', name: 'Uplay' },
  { id: 'HF', name: 'Cleartrip' },
  { id: 'HE', name: 'Mewt' },
  { id: 'HD', name: 'MarketPapa' },
  { id: 'HC', name: 'MOMO' },
  { id: 'GY', name: 'MIYACHAT' },
  { id: 'GV', name: 'Humta' },
  { id: 'GU', name: 'Fora' },
  { id: 'GS', name: 'SamsungShop' },
  { id: 'GQ', name: 'Freelancer' },
  { id: 'GN', name: 'A9A' },
  { id: 'GL', name: 'GlobalTel' },
  { id: 'GI', name: 'Hotline' },
  { id: 'GH', name: 'GyFTR' },
  { id: 'GG', name: 'PagSmile' },
  { id: 'GE', name: 'Paytm' },
  { id: 'GD', name: 'Surveytime' },
  { id: 'GA', name: 'Roposo' },
  { id: 'FY', name: 'Mylove' },
  { id: 'FW', name: '99acres' },
  { id: 'FV', name: 'Vidio' },
  { id: 'FS', name: 'Şikayet var' },
  { id: 'FP', name: 'Phound' },
  { id: 'FO', name: 'MobiKwik' },
  { id: 'FM', name: 'Touchance' },
  { id: 'FL', name: 'RummyLoot' },
  { id: 'FK', name: 'BLIBLI' },
  { id: 'FH', name: 'Lalamove' },
  { id: 'FG', name: 'IndianOil' },
  { id: 'FE', name: 'CliQQ' },
  { id: 'FC', name: 'PharmEasy' },
  { id: 'FA', name: 'XadrezFeliz' },
  { id: 'EY', name: 'miloan' },
  { id: 'EV', name: 'Picpay' },
  { id: 'EU', name: 'LiveScore' },
  { id: 'ER', name: 'Kwork' },
  { id: 'EP', name: 'Temu' },
  { id: 'EO', name: 'Sizeer' },
  { id: 'EM', name: 'ZéDelivery' },
  { id: 'EL', name: 'Bisu' },
  { id: 'EJ', name: 'MrQ' },
  { id: 'EI', name: 'Taksheel' },
  { id: 'EG', name: 'ContactSys' },
  { id: 'EF', name: 'Nextdoor' },
  { id: 'ED', name: 'Gamer' },
  { id: 'EC', name: 'RummyCulture' },
  { id: 'EB', name: 'Voltz' },
  { id: 'EA', name: 'JamesDelivery' },
  { id: 'DX', name: 'Powerkredite' },
  { id: 'DW', name: 'Divar' },
  { id: 'DV', name: 'NoBroker' },
  { id: 'DU', name: 'AUBANK' },
  { id: 'DM', name: 'Iwplay' },
  { id: 'DK', name: 'Pairs' },
  { id: 'DI', name: 'Loanflix' },
  { id: 'DD', name: 'CloudChat' },
  { id: 'DC', name: 'YikYak' },
  { id: 'DB', name: 'ezbuy' },
  { id: 'CZ', name: 'Getmega' },
  { id: 'CX', name: 'Icrypex' },
  { id: 'CW', name: 'PaddyPower' },
  { id: 'CV', name: 'WashXpress' },
  { id: 'CU', name: '炙热星河' },
  { id: 'CS', name: 'AgriDevelop' },
  { id: 'CQ', name: 'Mercado' },
  { id: 'CP', name: 'Uklon' },
  { id: 'CO', name: 'Rediffmail' },
  { id: 'CM', name: 'Prom' },
  { id: 'CL', name: 'UWIN' },
  { id: 'CK', name: 'BeReal' },
  { id: 'CJ', name: 'Dotz' },
  { id: 'CI', name: 'redBus' },
  { id: 'CH', name: 'Pocket52' },
  { id: 'CG', name: 'Gemgala' },
  { id: 'CF', name: 'irancell' },
  { id: 'CB', name: 'Bazos' },
  { id: 'CA', name: 'SuperS' },
  { id: 'BX', name: 'Dosi' },
  { id: 'BU', name: 'MonobankIndia' },
  { id: 'BT', name: 'Alfa' },
  { id: 'BS', name: 'TradeUP' },
  { id: 'BQ', name: 'Adani' },
  { id: 'BM', name: 'MarketGuru' },
  { id: 'BK', name: 'G2G' },
  { id: 'BI', name: '勇仕网络Ys4fun' },
  { id: 'BG', name: 'MIXMART' },
  { id: 'BC', name: 'GCash' },
  { id: 'BB', name: 'LazyPay' },
  { id: 'AZ', name: 'CityBase' },
  { id: 'AY', name: 'Ruten' },
  { id: 'AX', name: 'CrefisaMais' },
  { id: 'AU', name: 'Haraj' },
  { id: 'AT', name: 'Perfluence' },
  { id: 'AR', name: 'Wondermart' },
  { id: 'AQ', name: 'Glovo' },
  { id: 'AO', name: 'UU163' },
  { id: 'AF', name: 'GalaxyWin' },
  { id: 'AD', name: 'Iti' },
  { id: 'AA', name: 'Probo' },
  { id: 'BN', name: 'Alfagift' },
  { id: 'HY', name: 'Ininal' },
  { id: 'KE', name: 'Эльдорадо' },
  { id: 'CC', name: 'Quipp' },
  { id: 'EE', name: 'Twilio' },
  { id: 'KP', name: 'HQ Trivia' },
  { id: 'GZ', name: 'LYKA' },
  { id: 'AC', name: 'DoorDash' },
  { id: 'AI', name: 'CELEBe' },
  { id: 'AW', name: 'Taikang' },
  { id: 'KI', name: '99app' },
  { id: 'JL', name: 'Hopi' },
  { id: 'GM', name: 'Mocospace' },
  { id: 'ES', name: 'iQIYI' },
  { id: 'DY', name: 'Zomato' },
  { id: 'PR', name: 'Trendyol' },
  { id: 'GP', name: 'Ticketmaster' },
  { id: 'EQ', name: 'Qoo10' },
  { id: 'FULL', name: 'Full rent' },
  { id: 'LX', name: 'DewuPoison' },
  { id: 'WJ', name: '1xbet' },
  { id: 'HA', name: 'My11Circle' },
  { id: 'NW', name: 'Ximalaya' },
  { id: 'ZL', name: 'Airtel' },
  { id: 'PP', name: 'Huya' },
  { id: 'AK', name: 'Douyu' },
  { id: 'LY', name: 'Olacabs' },
  { id: 'DZ', name: 'Dominos Pizza' },
  { id: 'VS', name: 'WinzoGame' },
  { id: 'CR', name: 'TenChat' },
  { id: 'HG', name: 'Switips' },
  { id: 'GB', name: 'YouStar' },
  { id: 'PD', name: 'IFood' },
  { id: 'DT', name: 'Delivery Club' },
  { id: 'YG', name: 'CourseHero' },
  { id: 'NQ', name: 'Trip' },
  { id: 'QR', name: 'MEGA' },
  { id: 'RZ', name: 'EasyPay' },
  { id: 'KZ', name: 'NimoTV' },
  { id: 'MY', name: 'CAIXA' },
  { id: 'GR', name: 'Astropay' },
  { id: 'DF', name: 'Happn' },
  { id: 'DG', name: 'Mercari' },
  { id: 'PO', name: 'premium.one' },
  { id: 'IV', name: 'Inboxlv' },
  { id: 'BP', name: 'GoFundMe' },
  { id: 'GX', name: 'Hepsiburadacom' },
  { id: 'MI', name: 'Zupee' },
  { id: 'NR', name: 'Tosla' },
  { id: 'BO', name: 'Wise' },
  { id: 'GW', name: 'CallApp' },
  { id: 'QZ', name: 'Faceit' },
  { id: 'YU', name: 'Xiaomi' },
  { id: 'KJ', name: 'YAPPY' },
  { id: 'VE', name: 'Dream11' },
  { id: 'IL', name: 'IQOS' },
  { id: 'VG', name: 'ShellBox' },
  { id: 'SQ', name: 'KuCoinPlay' },
  { id: 'BA', name: 'Expressmoney' },
  { id: 'LI', name: 'Baidu' },
  { id: 'LC', name: 'Subito' },
  { id: 'ZI', name: 'LoveLocal' },
  { id: 'JF', name: 'Likee' },
  { id: 'GR_RD', name: 'Chalkboard' },
  { id: 'BOO', name: 'CasinoPlus' },
  { id: 'EBAY_KL', name: 'Kleinanzeigen' },
  { id: 'RKTN', name: 'Rakuten' },
  { id: 'ADS', name: 'GoChat' },
  { id: 'AGB', name: 'Smiles' },
  { id: 'OT', name: '任何其他' },
  { id: 'XO', name: 'Notifire' },
  { id: 'WU', name: 'PrivetMir' },
  { id: 'WY', name: 'Yami' },
  { id: 'XC', name: 'SynotTip' },
  { id: 'YR', name: 'Miravia' },
  { id: 'WR', name: 'Walmart' },
  { id: 'XG', name: 'FortunaSK' },
  { id: 'ZB', name: 'FreeNow' },
  { id: 'ZE', name: 'Shpock' },
  { id: 'VR', name: 'MotorkuX' },
  { id: 'WS', name: 'Indodax' },
  { id: 'ABQ', name: 'Upwork' },
  { id: 'GR_BF', name: 'Beanfun' },
  { id: 'ACZ', name: 'Claude' },
  { id: 'ENU', name: 'Emenu' },
  { id: 'NMKZ', name: 'Naimi.kz' },
  { id: 'MCR', name: 'MYCAR.KZ' },
  { id: 'AVT', name: 'Aviata.kz' },
  { id: 'UBR_GR', name: 'Universal Beijing Resort' },
  { id: 'ADQ', name: 'Uzum' },
  { id: 'AGM', name: 'CMB' },
  { id: 'AGK', name: 'Ipsos iSay' },
  { id: 'ZP', name: 'Pinduoduo' },
  { id: 'AAB', name: 'BharatPe' },
  { id: 'AAY', name: 'JioMart' },
  { id: 'ABS', name: 'Playerzpot' },
  { id: 'ACE', name: 'Tata Neu' },
  { id: 'ACF', name: 'Winter Loan' },
  { id: 'ACG', name: 'CollabAct' },
  { id: 'ACR', name: 'QwikCilver' },
  { id: 'ACS', name: 'Tata CLiQ Palette' },
  { id: 'ACU', name: 'CityMall' },
  { id: 'ACV', name: 'A23' },
  { id: 'ADB', name: 'PoshVine' },
  { id: 'ADG', name: 'Marwadi' },
  { id: 'ADH', name: 'Frizza' },
  { id: 'ADI', name: 'Zepto' },
  { id: 'ADJ', name: 'RummyCircle' },
  { id: 'ADK', name: 'Khatabook' },
  { id: 'ADL', name: 'EarnEasy' },
  { id: 'ADM', name: 'FitCredit' },
  { id: 'AEV', name: 'BankKaro' },
  { id: 'AFJ', name: 'SKCAPITAL' },
  { id: 'AFN', name: 'Roomster' },
  { id: 'AGO', name: 'Servify' },
  { id: 'AGP', name: 'Hdfcbank' },
  { id: 'AGQ', name: 'Bajaj Finserv' },
  { id: 'AGR', name: 'Yonogames' },
  { id: 'AHA', name: 'Angel One' },
  { id: 'AHT', name: 'MockGuru' },
  { id: 'AII', name: 'Hinge Dating' },
  { id: 'AED', name: 'Kamatera' },
  { id: 'ACK', name: 'Tomato' },
  { id: 'AAR', name: 'Bearwww' },
  { id: 'AGH', name: 'Anibis' },
  { id: 'AHE', name: 'Bunq' },
  { id: 'ABD', name: 'Beboo' },
  { id: 'ABN', name: 'Namars' },
  { id: 'ACN', name: 'Radium' },
  { id: 'ADX', name: 'BusyFly' },
  { id: 'AFP', name: 'VFS GLOBAL' },
  { id: 'AHK', name: 'БлинБери' },
  { id: 'AHM', name: 'BRO' },
  { id: 'AHX', name: 'Bitrue' },
  { id: 'AID', name: 'Kia' },
  { id: 'AIF', name: 'Royal Canin' },
  { id: 'AAW', name: 'Aya Bank' },
  { id: 'AAQ', name: 'Netease' },
  { id: 'ABA', name: 'Rappi' },
  { id: 'ADP', name: 'Cabify' },
  { id: 'AIJ', name: 'NEQUI' },
  { id: 'AAZ', name: 'Ozan' },
  { id: 'AIH', name: 'Fups' },
  { id: 'AER', name: 'PlayerAuctions' },
  { id: 'AFK', name: 'Chevron' },
  { id: 'AAS', name: 'XXGame' },
  { id: 'AAV', name: 'Alchemy' },
  { id: 'AAX', name: 'Boyaa' },
  { id: 'ABI', name: 'BytePlus' },
  { id: 'ABR', name: 'Privy' },
  { id: 'ACJ', name: 'Meituan' },
  { id: 'AAG', name: 'Pockit' },
  { id: 'AAP', name: 'Tiptapp' },
  { id: 'AAU', name: 'RockeTreach' },
  { id: 'ABC', name: 'Taptap Send' },
  { id: 'ABE', name: 'Foodora' },
  { id: 'ABZ', name: 'Friendtech' },
  { id: 'ACH', name: 'Haleon' },
  { id: 'ACY', name: 'Airtime' },
  { id: 'ADA', name: 'TRUTH SOCIAL' },
  { id: 'ADC', name: 'PlayOJO' },
  { id: 'AEC', name: 'JinJiang' },
  { id: 'AFT', name: 'Neocrypto' },
  { id: 'AFY', name: 'Tuul' },
  { id: 'AFZ', name: 'Klarna' },
  { id: 'AGC', name: 'VIMpay' },
  { id: 'AGD', name: 'Grailed' },
  { id: 'AGE', name: 'MTR Mobile' },
  { id: 'AGF', name: 'Meitu' },
  { id: 'AGG', name: 'OneForma' },
  { id: 'AGS', name: 'Abbott' },
  { id: 'ABK', name: 'GMX' },
  { id: 'ABO', name: 'WEBDE' },
  { id: 'AHJ', name: 'Strato' },
  { id: 'AHS', name: '1and1' },
  { id: 'AHV', name: 'Surveybell' },
  { id: 'ACD', name: 'CheckDomain' },
  { id: 'ACO', name: 'AR Lens' },
  { id: 'ACP', name: 'BonusLink' },
  { id: 'ACQ', name: 'Suntec' },
  { id: 'AEB', name: 'GoPayz' },
  { id: 'AEI', name: 'Tanoti' },
  { id: 'AFB', name: 'Maybank' },
  { id: 'AFM', name: 'Myboost' },
  { id: 'AGX', name: 'MeiQFashion' },
  { id: 'AHF', name: 'Fugeelah' },
  { id: 'AIG', name: 'K11' },
  { id: 'AIV', name: 'Striving in the Lion City' },
  { id: 'AGJ', name: 'Marktplaats' },
  { id: 'AIQ', name: 'Prime Opinion' },
  { id: 'ABT', name: 'ArenaPlus' },
  { id: 'ADT', name: 'Willhaben' },
  { id: 'AHD', name: 'OpenPhone' },
  { id: 'ADU', name: 'Seznam' },
  { id: 'AFW', name: 'Packeta' },
  { id: 'AGA', name: 'Publi24' },
  { id: 'AGL', name: 'Betano' },
  { id: 'AHW', name: 'Zasilkovna' },
  { id: 'ABU', name: 'BPJSTK' },
  { id: 'ADF', name: 'BCA Syariah' },
  { id: 'AEL', name: 'Cloud Manager' },
  { id: 'AEM', name: 'AstraPay' },
  { id: 'AEN', name: 'Redigame' },
  { id: 'AEO', name: 'Allofresh' },
  { id: 'AEP', name: 'ONBUKA' },
  { id: 'AEQ', name: 'Godrej' },
  { id: 'AET', name: 'Greywoods' },
  { id: 'AEU', name: 'TheFork' },
  { id: 'AEW', name: 'Flip' },
  { id: 'AEX', name: 'Neon' },
  { id: 'AFC', name: 'Bunda' },
  { id: 'AFD', name: 'Astra Otoshop' },
  { id: 'AFX', name: 'Gamesofa' },
  { id: 'AGN', name: 'Flik' },
  { id: 'AGZ', name: 'Jiva Petani' },
  { id: 'AHB', name: 'Ubisoft' },
  { id: 'AHO', name: 'UangMe' },
  { id: 'AHP', name: 'PizzaHut' },
  { id: 'AHQ', name: 'SEEDS' },
  { id: 'AIP', name: 'AfreecaTV' },
  { id: 'AIR', name: 'TipTip' },
  { id: 'AIS', name: 'Schibsted' },
  { id: 'AIT', name: 'FeetFinder' },
  { id: 'ACC', name: 'LuckyLand Slots' },
  { id: 'AHI', name: 'Daki' },
  { id: 'AGY', name: 'Baihe' },
  { id: 'AHR', name: 'This Fate' },
  { id: 'AGI', name: 'Njuškalo' },
  { id: 'ABB', name: 'Coca-Cola' },
  { id: 'ABX', name: 'Kaching' },
  { id: 'ABY', name: 'Couponscom' },
  { id: 'ACB', name: 'Spark Driver' },
  { id: 'ACL', name: 'Tiv' },
  { id: 'ACM', name: 'Razer' },
  { id: 'ADN', name: 'Zach Bryan' },
  { id: 'ADO', name: 'SmartyPig' },
  { id: 'AHY', name: 'Fliff' },
  { id: 'AIN', name: 'SpaceWeb' },
  { id: 'AIY', name: 'Nloto' },
  { id: 'AIZ', name: 'Brevo' },
  { id: 'AJL', name: 'Av100pro' },
  { id: 'AKF', name: 'Ollis' },
  { id: 'AJD', name: 'Bankera' },
  { id: 'AJA', name: 'G2A' },
  { id: 'AJE', name: 'CupidMedia' },
  { id: 'AJF', name: 'IPanelOnline' },
  { id: 'AJG', name: 'Fortumo' },
  { id: 'AJH', name: 'WAUG' },
  { id: 'AJJ', name: 'Rebtel' },
  { id: 'AJM', name: 'Gener8' },
  { id: 'AJN', name: 'Gopuff' },
  { id: 'AKD', name: 'Feels' },
  { id: 'AIK', name: 'ZUS Coffee' },
  { id: 'AIL', name: 'Zoo Game' },
  { id: 'AJO', name: 'CoffeeTea' },
  { id: 'AIX', name: 'Move It' },
  { id: 'AIO', name: 'Prakerja' },
  { id: 'AJK', name: 'Venteny' },
  { id: 'AJP', name: 'AsiaMiles' },
  { id: 'AJQ', name: 'MyValue' },
  { id: 'AJR', name: 'Boku' },
  { id: 'AJS', name: 'GetPlus' },
  { id: 'AJU', name: 'Daya Auto' },
  { id: 'AJV', name: 'ShareParty' },
  { id: 'AJW', name: 'INDOBA' },
  { id: 'AJX', name: 'Kemnaker RI' },
  { id: 'AJY', name: 'All Access' },
  { id: 'AJZ', name: 'MotionPay' },
  { id: 'AKA', name: 'LinkAja' },
  { id: 'LRMN', name: 'LEROY MERLIN' },
  { id: 'AKG', name: 'Book My Play' },
  { id: 'AKW', name: 'WINDS' },
  { id: 'AKO', name: 'Ryde' },
  { id: 'AKP', name: 'Her' },
  { id: 'AKQ', name: 'Blank Street' },
  { id: 'AKR', name: 'Voi' },
  { id: 'AKX', name: 'Sony LIV' },
  { id: 'AKS', name: 'Hanya' },
  { id: 'AKH', name: 'Prenagen Club' },
  { id: 'AKI', name: 'Tiketcom' },
  { id: 'AKJ', name: 'Easycash' },
  { id: 'AKK', name: 'Dagangan' },
  { id: 'AKL', name: 'DOKU' },
  { id: 'AKM', name: 'LOTTE Mart' },
  { id: 'AKN', name: 'Chakra Rewards' },
  { id: 'AKT', name: 'Xworldwallet' },
  { id: 'AKY', name: 'GOMOFY' },
  { id: 'ALI', name: 'StockyDodo' },
  { id: 'ALP', name: 'Mera Gaon' },
  { id: 'AKB', name: 'Gurmanika' },
  { id: 'AKE', name: 'DIKIDI' },
  { id: 'ALE', name: 'Lydia' },
  { id: 'ALM', name: 'Muzz' },
  { id: 'ALG', name: 'Ankama' },
  { id: 'ALO', name: 'Profee' },
  { id: 'ALD', name: 'Nice88' },
  { id: 'AKC', name: 'Paybis' },
  { id: 'ALH', name: 'Lion Parcel' },
  { id: 'ALA', name: 'GetResponse' },
  { id: 'ALN', name: 'Remotasks' },
  { id: 'ALV', name: 'TIER' },
  { id: 'ALS', name: 'Greggs' },
  { id: 'WMPL', name: 'Womply' },
  { id: 'PCP', name: 'Pcipay' },
  { id: 'GR_BG', name: 'Battlestate Games' },
  { id: 'HRNJIE', name: '华人街' },
  { id: 'AMF', name: 'Acko' },
  { id: 'AMG', name: 'SBI Card' },
  { id: 'AMA', name: 'WooPlus' },
  { id: 'AMB', name: 'Vercel' },
  { id: 'AME', name: 'Discover Hong Kong' },
  { id: 'AMD', name: 'Smart' },
  { id: 'ALT', name: 'Segari' },
  { id: 'ALU', name: 'BC Game' },
  { id: 'ALW', name: 'Vida' },
  { id: 'ALX', name: 'NutriClub' },
  { id: 'ALY', name: 'Bebeclub' },
  { id: 'AMM', name: 'Punjab citizen' },
  { id: 'AMI', name: 'TEAMORU' },
  { id: 'AMK', name: 'GORDAN' },
  { id: 'AMH', name: 'MitID' },
  { id: 'AMT', name: 'Moneyview' },
  { id: 'AEZ', name: 'Shein' },
  { id: 'ANE', name: 'Supercell' },
  { id: 'ANC', name: 'VARUS' },
  { id: 'CF_ID', name: 'CoinFantasy' },
  { id: 'PPL', name: 'PYYPL' },
  { id: 'MGRS', name: 'Migros' },
  { id: 'AML', name: 'Xbox' },
  { id: 'YLWW', name: 'Yellow' },
  { id: 'SATU_KZ', name: 'Satu' },
  { id: 'OB_UZ', name: 'OpenBudjet' },
  { id: 'SNL', name: 'Sonol' },
  { id: 'YUDAFR', name: 'Yuda' },
  { id: 'GMSG', name: 'Google Messenger' },
  { id: 'FST', name: 'Fastwin' },
  { id: 'MEEX', name: 'Media express' },
  { id: 'AVZ', name: 'Getsbet' },
  { id: 'ARS', name: 'Bingoplus' },
  { id: 'BRNC', name: 'Branch' },
  { id: 'PRCL', name: 'Poker Circle' },
  { id: 'AYK', name: 'Radquest' },
  { id: 'AOA', name: 'Hicard' },
  { id: 'LDPS', name: 'ludoplus' },
  { id: 'CTKT', name: 'ConfirmTkt' },
  { id: 'AXR', name: 'match.com' },
  { id: 'VRST', name: 'Verasight' },
  { id: 'GGMS', name: 'Goa games' },
  { id: 'BTNN', name: 'BETININ' },
  { id: 'AVB', name: 'Tealive' },
  { id: 'BUSQ', name: 'Busqo' },
  { id: 'NUUM', name: 'Nuum.ru' },
  { id: 'MUA', name: 'meta.ua' },
  { id: 'QCX', name: 'Narendra modi' },
  { id: 'NMCR', name: 'Namaskar' },
  { id: 'TJRM', name: 'Taj Rummy' },
  { id: 'HPNC', name: 'Happypancake' },
  { id: 'KEET', name: 'Keeta' },
  { id: 'HDFC', name: 'HDFC Egro' },
  { id: 'TMRO', name: 'Tomoro Coffee' },
  { id: 'FVSS', name: 'fivesurveys' },
  { id: 'BDX', name: 'Benjamin' },
  { id: 'DING', name: 'ding' },
  { id: 'APRNT', name: 'theAsianparent' },
  { id: 'TNST', name: 'Tune studio' },
  { id: 'ANI', name: 'Talabat' },
  { id: 'QIM', name: 'HPGas' },
  { id: 'AOS', name: 'Loloo' },
  { id: 'OLXKZ', name: 'OLXkz' },
  { id: 'OLXUA', name: 'OLXua' },
  { id: 'OLXPL', name: 'OLXpl' },
  { id: 'TALK', name: 'Talkatone' },
  { id: 'ETSY', name: 'Etsy' },
  { id: 'OLXRO', name: 'OLXro' },
  { id: 'OLXBG', name: 'OLXbg' },
  { id: 'OLXPT', name: 'OLXpt' },
  { id: 'GIT', name: 'GitHub' },
  { id: 'OLXUZ', name: 'OLXuz' },
  { id: 'SLS', name: 'Streamlabs' },
  { id: 'UNS', name: 'Unstop' },
  { id: 'STN', name: 'Stan' },
  { id: 'SWL', name: 'Swarail' },
  { id: 'ADE', name: 'Magicpin' },
  { id: 'BOC', name: '51exch' },
  { id: 'BBM', name: 'Truemoney' },
  { id: 'QJP', name: 'Innopay' },
  { id: 'HYP', name: 'Hypermart' },
  { id: 'VSN', name: 'Vision11' },
  { id: 'QIY', name: 'Saathi' },
  { id: 'APR', name: 'Capital One' },
  { id: 'BVA', name: 'Bingo101' },
  { id: 'BRH', name: 'Efsane' },
  { id: 'BGF', name: 'Rapido' },
  { id: 'QBS', name: 'Sixer' },
  { id: 'QHY', name: 'Omnicard' },
  { id: 'QCB', name: 'Shopsy' },
  { id: 'CGP', name: 'College Pulse' },
  { id: 'BQZ', name: 'Credit Karma' },
  { id: 'GNT', name: 'Gaintplay' },
  { id: 'TRC', name: 'TrapCall' },
  { id: 'KDS', name: 'Kudos' },
  { id: 'RSY', name: 'Resy' },
  { id: 'BLBK', name: 'Blastbucks' },
  { id: 'TMW', name: 'Timewall' },
  { id: 'APL', name: 'Sideline' },
  { id: 'JNO', name: 'Juno' },
  { id: 'BHI', name: 'Chase' },
  { id: 'DTC', name: 'Dutch Bros' },
  { id: 'CTR', name: 'CenturyLink' },
  { id: 'AUW', name: '3Fun' },
  { id: 'IBT', name: 'Ibotta' },
  { id: 'CIM', name: 'Acima' },
  { id: 'APTN', name: 'Aspiration' },
  { id: 'ARI', name: 'Ring4' },
  { id: 'TMI', name: 'Taimi' },
  { id: 'PLG', name: 'Pelago' },
  { id: 'TUM', name: 'Tumblr' },
  { id: 'AUD', name: 'Audible' },
  { id: 'RAP', name: 'RapidApi' },
  { id: 'SER', name: 'SerpApi' },
  { id: 'BOL', name: 'Bosslike' },
  { id: 'FMC', name: 'FMCPay' },
  { id: 'QBN', name: 'RummyYes' },
  { id: 'AWV', name: 'Wallapop' },
  { id: 'MML', name: 'MMLive' },
  { id: 'BNL', name: 'Reddit' },
  { id: 'QKS', name: 'Winclash' },
  { id: 'AUZ', name: 'Outlier' },
  { id: 'CTD', name: 'Courtyard' },
  { id: 'TBN', name: 'TurboTenant' },
  { id: 'GMY', name: 'BridgeMoney' },
  { id: 'ZLW', name: 'Zillow' },
  { id: 'SGK', name: 'SeatGeek' },
  { id: 'DAV', name: 'Dave' },
  { id: 'GHE', name: 'GetHoldings' },
  { id: 'XGU', name: 'RedNote / Xiaohongshu' },
  { id: 'BLR', name: 'DocuSign' },
  { id: 'BNU', name: 'Qpon' },
  { id: 'SRE', name: 'Starexch' },
  { id: 'PKR', name: 'Playkaro247' },
  { id: 'QKT', name: 'SpinWinner' },
  { id: 'AWQ', name: 'Atlas Earth' },
  { id: 'NST', name: 'Instamatch' },
  { id: 'QLD', name: 'Ludo11' },
  { id: 'QDX', name: 'Truemeds' },
  { id: 'HJ', name: 'Nykaa' },
  { id: 'QRR', name: 'Roz Rummy' },
  { id: 'PZR', name: 'Paisabazaar' },
  { id: 'BOU', name: '汇旺 Huione Pay' },
  { id: 'SKLS', name: 'Skills' },
  { id: 'CRSR', name: 'Cursor' },
  { id: 'AWS', name: 'Aws' },
  { id: 'QIV', name: 'Goldsbet' },
  { id: 'QJM', name: 'Cricbuzz' },
  { id: 'QIT', name: 'Royaljeet' },
  { id: 'AVK', name: 'Quoka' },
  { id: 'FPX', name: '500px' },
  { id: 'AQJ', name: 'BigBasket' },
  { id: 'GHT', name: 'Google Chat' },
  { id: 'BWB', name: 'Winmatch' },
  { id: 'CPT', name: 'Chipotle' },
  { id: 'WFARGO', name: 'Wells Fargo' },
  { id: 'QKZ', name: 'Govinda365' },
  { id: 'QLY', name: 'Woohoo' },
  { id: 'QBK', name: 'First Games' },
  { id: 'KCH', name: 'KickCash' },
  { id: 'HRA', name: 'Aadhar' },
  { id: 'QJW', name: 'Shriram One' },
  { id: 'PON', name: 'Pokemon' },
  { id: 'AOG', name: 'Naukri' },
  { id: 'QJB', name: 'Okwin' },
  { id: 'SHT', name: 'ShareChat' },
  { id: 'QMF', name: 'Dream Money' },
  { id: 'KNY', name: 'Konvy' },
  { id: 'BSW', name: 'Milanuncios' },
  { id: 'KIQ', name: 'Kliq' },
  { id: 'JAU', name: 'Jiagu360' },
  { id: 'BEX', name: 'Whatnot' },
  { id: 'BHL', name: 'Ati.su' },
  { id: 'QCZ', name: 'Creditmantri' },
  { id: 'QAF', name: 'Cred' },
  { id: 'QQL', name: 'QQLive' },
  { id: 'CLG', name: 'Clubgg' },
  { id: 'PLA', name: 'PolloAI' },
  { id: 'TLN', name: 'Toluna' },
  { id: 'KCK', name: 'Kick' },
  { id: 'BLB', name: 'foundit' },
  { id: 'BZB', name: 'Big Cash' },
  { id: 'ESZ', name: 'Ez777' },
  { id: 'DPS', name: 'FDJ Parions Sport' },
  { id: 'EVE', name: 'Enilive' },
  { id: 'BLE', name: 'NEXON' },
  { id: 'QML', name: 'Ranglive' },
  { id: 'UTA', name: 'BEUTEA' },
  { id: 'QGH', name: 'Indiapolls' },
  { id: 'QFF', name: 'Aditya birla' },
  { id: 'HEP', name: 'HeyPiggy' },
  { id: 'BBF', name: 'Neosurf' },
  { id: 'TUI', name: 'Tutti' },
  { id: 'BDP', name: 'Kredito' },
  { id: 'SLI', name: 'Sponline' },
  { id: 'BRG', name: 'Letgo' },
  { id: 'IDO', name: 'Idee Opinioni' },
  { id: 'AWG', name: 'Natura Avon' },
  { id: 'OPD', name: 'Poe' },
  { id: 'GUV', name: 'Guvi' },
  { id: 'QMQ', name: 'QuickTv' },
  { id: 'KLB', name: 'Kolotibablo' },
  { id: 'MLK', name: 'Mackolik' },
  { id: 'ZMX', name: 'Zenmux' },
  { id: 'JWC', name: 'Jalwa Game' },
  { id: 'APA', name: 'Exness' },
  { id: 'QMP', name: 'Tata Motors' },
  { id: 'RCH', name: 'Research 360' },
  { id: 'LID', name: 'Ludo Winner' },
  { id: 'MEB', name: 'MBMBet' },
  { id: 'LOG', name: 'Long Chau' },
  { id: 'TIT', name: 'TIM IT' },
  { id: 'WMB', name: 'Wamba' },
  { id: 'BYH', name: 'Adobe' },
  { id: 'DAH', name: 'DahaDaha' },
  { id: 'AOF', name: 'Guzman y Gomez' },
  { id: 'GUC', name: 'SwagBucks' },
  { id: 'ODL', name: 'Ricardo' },
  { id: 'LMD', name: 'Ashley Madison' },
  { id: 'OTK', name: '51game' },
  { id: 'OTR', name: 'Story TV' },
  { id: 'TME', name: 'OurTime' },
  { id: 'ELS', name: 'Nielsen' },
  { id: 'TNX', name: 'Telnyx' },
  { id: 'GRK', name: 'Grok' },
  { id: 'TIS', name: 'WinMate' },
  { id: 'ASJ', name: 'T-Online' },
  { id: 'QHB', name: 'Dot and Key' },
  { id: 'TOD', name: 'TheDermaCo' },
  { id: 'KIR', name: 'Predik' },
  { id: 'YAB', name: 'Brevistay' },
  { id: 'USP', name: 'Australia Post' },
  { id: 'QHP', name: 'CheQ' },
  { id: 'IOY', name: 'Rupiyo' },
  { id: 'DGO', name: 'DigitalOcean' },
  { id: 'IDR', name: 'FDA' },
  { id: 'AWZ', name: 'PlayTime' },
  { id: 'BMJ', name: 'Betflag' },
  { id: 'BMI', name: 'Sisal' },
  { id: 'BQE', name: 'Lottomatica' },
  { id: 'GAL', name: 'Goldbet' },
  { id: 'BRT', name: 'Netwin' },
  { id: 'BQY', name: 'SNAI' },
  { id: 'BHZ', name: 'Eurobet' },
  { id: 'NNE', name: 'OneOne' },
  { id: 'BCQ', name: 'Kopi Kenangan' },
  { id: 'BAQ', name: 'Redbubble' },
  { id: 'TTN', name: 'Textnow' },
  { id: 'AGU', name: 'Story Max' },
  { id: 'AMP', name: 'Timepass' },
  { id: 'OJI', name: 'Ajio' },
  { id: 'GOR', name: 'Redrob Signal' },
  { id: 'GUN', name: 'Hungry Panda' },
  { id: 'FOG', name: 'Flamingo' },
  { id: 'YTO', name: 'Anna Lottery' },
  { id: 'SAJ', name: 'Raja Games' },
  { id: 'EDO', name: 'RusDate' },
  { id: 'HUG', name: 'Driv&' },
  { id: 'OMX', name: 'Angi' },
  { id: 'PEV', name: 'WPlace' },
  { id: 'KON', name: 'Monkey' },
  { id: 'GAH', name: 'Pazarama' },
  { id: 'GYT', name: 'BetExc' },
  { id: 'WFO', name: 'Ownly' },
  { id: 'MAX', name: 'MAX' },
  { id: 'BFL', name: 'Black Forest Labs' },
  { id: 'WND', name: 'Windsurf' },
  { id: 'CWG', name: 'CWG' },
  { id: 'CCV', name: 'Triumph' },
  { id: 'OXH', name: 'Oxinchain' },
  { id: 'WKU', name: 'WorkUA' },
  { id: 'DAZ', name: 'LODA' },
  { id: 'MLN', name: 'Mulerun' },
  { id: 'STD', name: 'Seated' },
  { id: 'QZN', name: 'Qzino' },
  { id: 'HDT', name: 'Hindustan' },
  { id: 'AYC', name: 'HungerStation' },
  { id: 'KAC', name: 'Chick Fil A' },
  { id: 'OHA', name: 'AstroChat' },
  { id: 'CDY', name: 'Caddy' },
  { id: 'FYT', name: 'Cityflo' },
  { id: 'DEN', name: 'FriendshipHub' },
  { id: 'BPC', name: 'LOVOO' },
  { id: 'NIU', name: 'MILKRUN' },
  { id: 'UME', name: 'Premium Bandai' },
  { id: 'LUF', name: 'Luckin Coffee' },
  { id: 'AYZ', name: 'Kimi' },
  { id: 'OWP', name: 'Owlproxy' },
  { id: 'TSP', name: 'Trustpilot' },
  { id: 'NTP', name: 'NextOtp' },
  { id: 'OTY', name: 'Jaya Slot' },
  { id: 'TTM', name: 'TextMe' },
  { id: 'KVB', name: 'KVB' },
  { id: 'GVC', name: 'Zoom' },
  { id: 'FED', name: 'Cline' },
  { id: 'QKP', name: 'Quarkip' },
  { id: 'HTV', name: 'Hotlive' },
  { id: 'VND', name: 'WOW88' },
  { id: 'JDZ', name: 'Hopegoo' },
  { id: 'BCW', name: 'KodBende' },
  { id: 'PMV', name: 'Prime video' },
  { id: 'TKS', name: 'Tiktok shop' },
  { id: 'AUX', name: 'Lightning AI' },
  { id: 'BNN', name: 'Binance' },
  { id: 'PTS', name: 'Piattos' },
  { id: 'POY', name: 'SportyBet' },
  { id: 'SPR', name: 'Super.com' },
  { id: 'JDS', name: 'Idle Empire' },
  { id: 'FLF', name: 'FetLife' },
  { id: 'IMD', name: 'IMDb' },
  { id: 'QNC', name: 'QwenCloud' }
]

/**
 * 项目类型分类。
 */
export const projectTypes = {
  social: '社交应用',
  dating: '交友约会',
  ecommerce: '电商平台',
  entertainment: '娱乐游戏',
  tech: '科技服务',
  payment: '支付金融',
  other: '其他'
}

/**
 * 根据项目名称智能识别类型。
 */
export function getProjectType(projectName) {
  const lowerName = projectName.toLowerCase()

  if (/telegram|whatsapp|facebook|instagram|twitter|wechat|qq|discord|signal|viber|line|kakao|zalo|snapchat|tiktok|douyin|weibo|momo/i.test(lowerName)) {
    return 'social'
  }

  if (/tinder|bumble|hinge|tantan|soul|date|dating|match|meet|cupid|love|sweetring|omiai/i.test(lowerName)) {
    return 'dating'
  }

  if (/amazon|alibaba|taobao|jd|shopee|wish|ebay|lazada|nike|uber|grab|foodpanda|deliveroo|meituan|eleme/i.test(lowerName)) {
    return 'ecommerce'
  }

  if (/game|play|tv|live|steam|blizzard|pubg|netflix|bilibili|taptap|maple|nimo/i.test(lowerName)) {
    return 'entertainment'
  }

  if (/google|microsoft|apple|yahoo|openai|claude|chatgpt|aws|azure|baidu|naver|zoho/i.test(lowerName)) {
    return 'tech'
  }

  if (/pay|wallet|bank|card|cash|money|alipay|gcash|dana|payment|finance/i.test(lowerName)) {
    return 'payment'
  }

  return 'other'
}

/**
 * 按项目名称或数据库项目 code 搜索项目。
 */
export function searchProjects(keyword) {
  if (!keyword) return internationalProjects

  const lowerKeyword = keyword.toLowerCase()
  return internationalProjects.filter(project =>
    project.name.toLowerCase().includes(lowerKeyword) ||
    project.id.toLowerCase().includes(lowerKeyword)
  )
}

internationalProjects.forEach(project => {
  project.type = getProjectType(project.name)
})
